var awardsSlider = {
    init: function() {
        var GalleryleftMargin = 0;
        var GalleryrightMargin = 0;
        var width = $('#gallery-section').width() - $('#gallery-parent').width() + 147;
        var ElementWidth = $('.seven-cols-img').width() + 16;

        if (window._d.isRTL) {
            $('#scroll-left').removeClass('hidden').addClass('block');
        } else {
            $('#scroll-right').removeClass('hidden').addClass('block');
        }

        $('#scroll-left').on('click', function() {

            if (window._d.isRTL) {
                $('#gallery-section').animate({
                    marginRight: '-=' + ElementWidth
                }, 'medium');

            } else {
                $('#gallery-section').animate({
                    marginLeft: '+=' + ElementWidth
                }, 'medium');
            }

            if (window._d.isRTL) {
                $('#scroll-left').removeClass('hidden').addClass('block');
            } else {
                $('#scroll-right').removeClass('hidden').addClass('block');
            }

            GalleryleftMargin = (GalleryleftMargin - ElementWidth);
            GalleryrightMargin = (GalleryrightMargin + ElementWidth);

            if (window._d.isRTL) {
                if (GalleryrightMargin > 0) {
                    $('#scroll-right').removeClass('hidden').addClass('block');
                }
                if (GalleryrightMargin > width - ElementWidth) {
                    $('#scroll-left').removeClass('block').addClass('hidden');
                }

            } else if (GalleryleftMargin === 0) {
                $('#scroll-left').removeClass('block').addClass('hidden');
            }
        });
        $('#scroll-right').on('click', function() {

            if (window._d.isRTL) {
                $('#gallery-section').animate({
                    marginRight: '+=' + ElementWidth
                }, 'medium');
            } else {
                $('#gallery-section').animate({
                    marginLeft: '-=' + ElementWidth
                }, 'medium');
            }

            $('#scroll-left').removeClass('hidden').addClass('block');

            if (window._d.isRTL) {
                GalleryrightMargin = (GalleryrightMargin - ElementWidth);
                if (GalleryrightMargin === 0) {
                    $('#scroll-right').removeClass('block').addClass('hidden');
                }
            } else {
                GalleryleftMargin = (GalleryleftMargin + ElementWidth);
                if (GalleryleftMargin > width - ElementWidth) {
                    $('#scroll-right').removeClass('block').addClass('hidden');
                }
            }
        });

        $('#gallery-block').hover(
            function() {
                if (window._d.isRTL) {
                    if (GalleryrightMargin === 0 || GalleryrightMargin < width - ElementWidth) {
                        $('#scroll-left').removeClass('hidden').addClass('block');
                    }
                } else if (GalleryleftMargin === 0 || GalleryleftMargin < width - ElementWidth) {
                        $('#scroll-right').removeClass('hidden').addClass('block');
                    }
            }, function() {
                if (window._d.isRTL) {
                    $('#scroll-left').removeClass('block').addClass('hidden');
                } else {
                    $('#scroll-right').removeClass('block').addClass('hidden');
                }
            }
        );
    }
};
